ko.extenders.nullableEnum = (target, options) => {
    var result = ko.pureComputed({
        read: () => String(target()),  //always return the original observables value
        write: (newValue) => {
            var current = target(),
                newValueAsNum = newValue === null || newValue === '' || isNaN(newValue) ? '' : parseInt(+newValue, 10),
                valueToWrite = newValueAsNum;

            //only write if it changed
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else {
                //if the tested value is the same, but a different value was written, force a notification for the current field
                if (newValue !== current) {
                    target.notifySubscribers(valueToWrite);
                }
            }
        }
    }).extend({ notify: 'always' });

    result(target());

    return result;
};

ko.extenders.globalizedNumber = (target) => {
    const result = ko.pureComputed({
        read: () => {
            const value = target();
            if (typeof value !== "number" || isNaN(value) || value === null || value === undefined || value === "") {
                return "";
            }
            return Globalize.formatNumber(value);
        },
        write: (newValue) => {
            if (newValue === null || newValue === undefined || newValue === "") {
                target(null);
                return;
            }
            if (typeof newValue === "number") {
                target(newValue);
                return;
            }
            const parsed = Globalize.parseNumber(newValue);
            target(isNaN(parsed) ? null : parsed);
        }
    });

    result(target());

    return result;
};